import { blue, red } from "@ant-design/colors";
import { Avatar } from "antd";
import { GoDotFill } from "react-icons/go";
import styled from "styled-components";

export const StyledUserInfoWrapper = styled.div`
  min-width: 200px;
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const StyledDropdownWrapper = styled.div<{ height: number }>`
  height: ${({ height }) => `${height}px`};
  background-color: transparent;
  border: 1px dashed ${({ theme }) => theme.palette.borderColor};
  border-radius: 5px;
`;

export const StyledNotifyLink = styled.a`
  display: flex;
  align-items: center;
  justify-content: center;
  width: auto;
  height: 100%;
  font-size: inherit;
  border-radius: 0;
  color: ${({ theme }) => theme.palette.text.primary};
  background-color: transparent;
`;

export const StyledNotifyIcon = styled.span`
  position: relative;
`;

export const StyledCrUserInfoAvatar = styled(Avatar)`
  font-size: 24px;
  background-color: ${({ theme }) => theme.palette.orange[6]};
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const StyledCrUserInfoContent = styled.span`
  transition: all 0.2s ease;
  margin-bottom: 5px;

  [dir="rtl"] & {
    margin-left: 0;
    margin-right: 16px;
  }
`;

export const StyledUsernameInfo = styled.span`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const StyledUsername = styled.h3`
  margin-bottom: 0;
  font-size: ${({ theme }) => theme.font.size.lg};
  font-weight: ${({ theme }) => theme.font.weight.medium};
  color: inherit;

  &.light {
    color: inherit;
  }
`;

export const StyledCrUserDesignation = styled.span`
  margin-top: -2px;
  color: inherit;
  font-size: ${({ theme }) => theme.font.size.base};

  .ant-layout-sider-dark & {
    color: inherit;
  }
`;

export const StyledDropdownCopyTokenItem = styled.div`
  color: ${({ theme }: { theme: any }) =>
    theme.palette.text.secondary}!important;

  span {
    font-size: 9px;
  }
`;

export const StyledUserHeaderName = styled.span`
  display: flex;
  align-items: center;
  font-size: ${({ theme }) => theme.font.size.lg};
  line-height: ${({ theme }) => theme.font.size.lg};
  font-weight: ${({ theme }) => theme.font.weight.medium};
  text-transform: uppercase;
  padding: 5px;
  border-radius: 5px;
  color: ${({ theme }: { theme: any }) => theme.palette.text.primary}!important;
  background-color: ${({ theme }) => theme.palette.background.default};
  height: inherit;

  .ant-typography {
    font-size: ${({ theme }) => theme.font.size.lg};
    line-height: ${({ theme }) => theme.font.size.lg};
    font-weight: ${({ theme }) => theme.font.weight.medium};
    color: ${({ theme }: { theme: any }) =>
      theme.palette.text.primary}!important;
    text-transform: uppercase;
    word-break: keep-all;
  }

  svg {
    margin-left: 5px;
  }
`;

export const StyledUserOnlineDot = styled(GoDotFill)`
  color: ${blue[5]};
  font-size: 15px;
  margin-right: 5px;
  margin-left: 0;
  padding-left: 0;

  svg {
    margin-left: 0;
    padding-left: 0;
  }
`;

export const StyledUserOfflineDot = styled(GoDotFill)`
  color: ${red[5]};
  font-size: 15px;
  margin-right: 5px;
  margin-left: 0;
  padding-left: 0;

  svg {
    margin-left: 0;
    padding-left: 0;
  }

  animation: blink 1.5s infinite;

  @keyframes blink {
    0% {
      opacity: 1;
    }
    50% {
      opacity: 0;
    }
    100% {
      opacity: 1;
    }
  }
`;
